import classNames from 'classnames';
import React, { useEffect } from 'react';

import styles from './ProductsList.module.scss';

import { productsStore } from '@/entities/product/store/productsStore';
import { ProductCard } from '@/entities/product/ui/ProductCard/ProductCard';
import { observer } from '@/shared/lib/signal/observer';
import { AnchorMenu } from '@/shared/ui-kit/AnchorMenu/AnchorMenu';
import { ProgressLoader } from '@/shared/ui-kit/ProgressLoader/ProgressLoader';

interface CatalogProps {
  restaurantId: number;
}

export const ProductsList: React.FC<CatalogProps> = observer(
  ({ restaurantId }) => {
    useEffect(() => {
      productsStore.loadProducts(restaurantId);
    }, [restaurantId]);

    return (
      <>
        {productsStore.loading.value ? (
          <div className={styles.loading}>
            <ProgressLoader mode="spinner" active done={false} />
          </div>
        ) : (
          <AnchorMenu
            sections={Object.values(productsStore.grouped.value).map(
              (group) => ({
                ...group,
                content: (
                  <div className={classNames('row', styles.row)} key={group.id}>
                    {group.products.map((p) => (
                      <div key={p.id} className="col-6">
                        <ProductCard product={p} />
                      </div>
                    ))}
                  </div>
                ),
              })
            )}
          />
        )}
      </>
    );
  }
);
